export const LOGIN_MODAL = "LOGIN_MODAL";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const CREATE_REQUEST = "CREATE_REQUEST";
export const SET_REQUEST = "SET_REQUEST";
export const GET_USER = "GET_USER";
export const LOG_OUT = "LOG_OUT";
export const SET_SELECTED_CARE_PRINCIPAL = "SET_SELECTED_CARE_PRINCIPAL";
export const SET_CARE_PRINCIPAL_FORM = "SET_CARE_PRINCIPAL_FORM";
export const SET_URL_QUERY_STATE = "SET_URL_QUERY_STATE";
export const RESET_URL_QUERY_STATE_PARAMS = "RESET_URL_QUERY_STATE_PARAMS";
export const SAVE_URL_QUERY_STATE = "SAVE_URL_QUERY_STATE";
export const GET_SESSION_TIME_OUT = "GET_SESSION_TIME_OUT";
export const SET_SESSION_TIME_OUT = "SET_SESSION_TIME_OUT";
export const SET_SELECTED_MENU_ITEM = "SET_SELECTED_MENU_ITEM";

export const setCurrentUser = (currentUser: any) => ({
  type: SET_CURRENT_USER,
  currentUser,
});
export const setURLQueryState = (urlQueryState: any) => ({
  type: SET_URL_QUERY_STATE,
  urlQueryState,
});

export const resetURLQueryState = () => ({
  type: RESET_URL_QUERY_STATE_PARAMS,
});

export const setSessionTimeOut = (sessionTimeout: any) => ({
  type: SET_SESSION_TIME_OUT,
  sessionTimeout,
});

export const setRequest = (request: any) => ({
  type: SET_REQUEST,
  request,
});

export const setSelectedCarePrincipal = (selectedCarePrincipal: any) => ({
  type: SET_SELECTED_CARE_PRINCIPAL,
  selectedCarePrincipal,
});

export const setCarePrincipalForm = (carePrincipalForm: any) => ({
  type: SET_CARE_PRINCIPAL_FORM,
  carePrincipalForm,
});

export const setSelectedMenuItem = (menuItem: any) => ({
  type: SET_SELECTED_MENU_ITEM,
  menuItem
})

const initialState = {
  currentUser: null,
  request: null,
  urlQueryState: null,
  sessionTimeout: null,
  menuItem: ""
};

export const currentUserReducer = (state = initialState, action: any) => {

  switch (action.type) {
    case SET_CURRENT_USER:
      const { currentUser } = action;
      return { ...state, currentUser };
    case SET_URL_QUERY_STATE:
      const { urlQueryState } = action;
      return { ...state, urlQueryState };
    case RESET_URL_QUERY_STATE_PARAMS:
      return { ...state, urlQueryState: {ssn: null, nature: null, embedded: null} };
    case SET_SESSION_TIME_OUT:
      const { sessionTimeout } = action;
      return { ...state, sessionTimeout };
    case SET_REQUEST:
      const { request } = action;
      return { ...state, request };
    case SET_SELECTED_CARE_PRINCIPAL:
      const { selectedCarePrincipal } = action;
      return { ...state, selectedCarePrincipal };
    case SET_CARE_PRINCIPAL_FORM:
      const { carePrincipalForm } = action;
      return { ...state, carePrincipalForm };
    case SET_SELECTED_MENU_ITEM:
      const { menuItem } = action;
      return { ...state, menuItem }
    default:
      return state;
  }
};
